import React from "react";
import Header from "../../components/header";
import Loading from "../../components/loading";
import ProcessingDialog from "./components/ProcessingDialog";
import useReviewInvoice from "./hooks/use-review-invoice";

export default function ReviewInvoice() {
  const state = useReviewInvoice();

  if (state.loading) return <Loading />;

  return (
    <>
      <Header>
        <div className="py-6 text-3xl font-semibold text-white">
          Review Invoice
        </div>
      </Header>
      {!state.loading && <div className="flex flex-col justify-between">
        <div className="container mx-auto mt-16 overflow-hidden rounded-md shadow-md">
          <div className="flex flex-col w-full px-10 py-8 bg-white">
            <div className="flex items-baseline gap-4">
              <div className="text-2xl font-semibold text-primary-blue">
                Charts for {state.readableElectionDate}
              </div>
              <div className="text-lg text-[#757575] font-sourceSansPro font-normal">
                {state.orderItems.length} Charts
              </div>
            </div>
            <div className="flex mt-5">
              <div className="bg-[#F2F5FA] p-5 flex rounded-md">
                <input
                  type="checkbox"
                  className="w-5 h-5 cursor-pointer"
                  checked={state.requestPrinting}
                  onChange={() => state.updateRequestPrinting()}
                />
                <div className="ml-4 font-normal text-[#272727]">
                  Request printing of my charts for $10 each.
                </div>
              </div>
            </div>
            {state.orderItems.map((item, i) => (
              <div className="mt-8" key={`order-item-${i}-${item.precinct}`}>
                <hr />
                <div className="mt-8">
                  <div className="flex justify-between">
                    <div className="text-lg font-semibold tracking-wider uppercase text-primary-blue">
                      {item.municipality}
                    </div>
                    <div className="text-lg font-semibold tracking-wider">
                      ${item.price}.00
                    </div>
                  </div>
                  <div className="font-normal text-sm text-[#757575] font-sourceSansPro">
                    Precinct {item.precinct} | {item.county} County |{" "}
                    {state.readableElectionDate}
                  </div>
                </div>
              </div>
            ))}
            {state.requestPrinting &&
              <div className='mt-8 border-t'>
                <div className='mt-8'>
                  <div className="flex justify-between">
                    <div className="text-lg font-semibold tracking-wider uppercase text-primary-blue">
                      Requested Print
                    </div>
                    <div className="text-lg font-semibold tracking-wider">
                      ${state.printingCost}.00
                    </div>
                  </div>
                  <div className="font-normal text-sm text-[#757575] font-sourceSansPro">
                    {state.orderItems.length ?? ''} chart{state.orderItems.length === 1 ? '' : 's'}
                  </div>
                </div>
              </div>
            }
            <div className="mt-8">
              <hr />
              <div className="flex justify-end gap-2 mt-8 text-xl tracking-wider text-primary-blue">
                <div className="uppercase">Total:</div>
                <div className="font-semibold">${state.total}.00</div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full py-8 mt-16 bg-white">
          <div className="container flex justify-end gap-8 mx-auto">
            <button
              onClick={state.cancel}
              className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Cancel
            </button>
            <button
              onClick={state.submitInvoice}
              className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Submit Invoice
            </button>
          </div>
        </div>
      </div>}
      <ProcessingDialog state={state} />
    </>
  );
}
